module.exports = __webpack_public_path__ + "img/LV4.0b7197ca.webp";